
export function ValidacaoNif(nif, tamanhoNif,t) {

    var msgNif = "";
    var nifValido = true;

    const nifCodigo1 = nif.substring(0, 1);
    const nifCodigo2 = nif.substring(1, 2);
    const verificacaoCodigo1 = /^[^a-zA-Z]*$/.test(nifCodigo1);
    const verificacaoCodigo2 = /^[^a-zA-Z]*$/.test(nifCodigo2);
    const nifRecebido = nif.substring(2, tamanhoNif);
    const verificacaoNif = /^[^a-zA-Z]*$/.test(nifRecebido);
    const verificacaoCarateres =
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(nif);
    //Nif com menos de 11 dígitos
    if (nif.length < tamanhoNif) {
        nifValido = false;
        msgNif = t("validacaoNif") + tamanhoNif + t("digitos")
    }
    //Nif e código incorretos
    if (
        //Primeiro digito incorreto restante verdadeiro
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 != false &&
            verificacaoCodigo2 != true &&
            verificacaoNif == false) ||
        //Segundo dígito incorreto restante verdadeiro
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 != true &&
            verificacaoCodigo2 != false &&
            verificacaoNif == false) ||
        //Nif correto, primeiro digito correto, segundo incorreto
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 != false &&
            verificacaoCodigo2 != false &&
            verificacaoNif == false)
    ) {
        nifValido = false;
        msgNif = t("validacaoNif2");
    }
    //Nif com 11 dígitos, nif correto mas primeiros dois dígitos incorretos
    if (
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 == true &&
            verificacaoCodigo2 == true &&
            verificacaoNif == true) ||
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 == false &&
            verificacaoCodigo2 == true &&
            verificacaoNif == true) ||
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 == true &&
            verificacaoCodigo2 == false &&
            verificacaoNif == true)
    ) {
        nifValido = false;
        msgNif = t("validacaoNif3")
    }
    //Código correto, nif incorreto
    if (
        (nif.length == tamanhoNif &&
            verificacaoCodigo1 == false &&
            verificacaoCodigo2 == false &&
            verificacaoNif == false) ||
        verificacaoCarateres == true
    ) {
        nifValido = false
        msgNif = t("validacaoNif4")
    }


    return {
        nifValido,
        msgNif
    }

}